import { PdfDialogComponent } from '@shared/pdf-dialog/pdf-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Lightbox } from 'ngx-lightbox';
import { UploadHttpService } from '@core/services/upload-http.service';
import { Component, OnInit, Input, OnDestroy, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { FormControl, FormArray, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { catchError, tap, finalize, map } from 'rxjs/operators';
import { MerchantBank } from '@core/models/merchant-bank.model';
import { MerchantBankDataService } from '@views/pages/apps/settings/merchant-banks/services/merchant-bank-data.service';
import { Observable, Subscription } from 'rxjs';
import { WithdrawMultiBankTransaction } from '@core/models/withdraw-multi.model';
import { WithdrawDataService } from '../../services/withdraw-data.service';
import { WithdrawEntityService } from '../../services/withdraw-entity.service';
import Swal from 'sweetalert2';
import { AppPermissionService } from '@core/services/app-permission.service';
import { DecimalPipe } from '@angular/common';
import { BankTransactionStatus } from '@core/enums/bank-transaction-status.enum';
import { BankTypes } from '@core/enums/bank-type.enum';
import { WithdrawBankTransaction } from '@core/models/withdraw-bank-transaction.model';
import { Withdraw } from '@core/models/withdraw.model';
import { WithdrawStatus } from '@core/enums/withdraw-status.enum';
import { ShowRemarkHistoryComponent } from '../../../deposits/dialogs/show-remark-history/show-remark-history.component';
import { EventEmitterService } from '@core/services/event-emitter.service';

declare var $: any;
@Component({
  selector: 'kt-withdrawal-multi',
  templateUrl: './withdrawal-multi.component.html',
  styleUrls: ['./withdrawal-multi.component.scss']
})
export class WithdrawalMultiDialogComponent implements OnInit, OnDestroy {
  BankTransactionStatusEnum = BankTransactionStatus;
  BankTypeEnum = BankTypes;
  WithdrawStatusEnum = WithdrawStatus;

  form: FormGroup;
  banks = new FormArray([]);

  @Input()
  status: number;

  @Input()
  purposeId: number;

  @Input()
  id: number;

  @Input()
  currencyId: number;

  @Input()
  confirmedAmount: number;

  @Input()
  withdrawalDetails: any;

  @Input()
  withdrawalBankType: any;

  @Input()
  bankTransactions: Array<WithdrawBankTransaction>;

  @Input()
  bankTransactionButtonLoading: boolean;

  @Input()
  from: 'member' | 'affiliate' = 'member';

  @Input()
  merchantBanksSource$?: Observable<MerchantBank[]>;

  @Input()
  delegatePayout = false;

  @Output()
  changed = new EventEmitter<WithdrawMultiBankTransaction>();

  @Output()
  update = new EventEmitter<WithdrawMultiBankTransaction>();

  @Output()
  payButtonExist = new EventEmitter<boolean>();

  @Output()
  approveBankTransaction = new EventEmitter<{ payload: { index: number } }>();

  @Output()
  payoutBankTransaction = new EventEmitter<{ payload: { index: number } }>();

  @Output()
  payoutBankTransaction2 = new EventEmitter<{ payload: { index: number } }>();

  @Output()
  updateWithdraw = new EventEmitter<{ withdraw: Withdraw, bank_transactions: Array<WithdrawBankTransaction> }>();

  merchantBanks: MerchantBank[] = [];
  filteredMerchantBanks: MerchantBank[] = [];

  bankaccountDropdownSettings = {
    singleSelection: true,
    text: 'Please Select',
    enableFilterSelectAll: false,
    enableSearchFilter: true,
    classes: 'dropdown',
    primaryKey: 'labelKey',
    labelKey: 'labelKey',
    noDataLabel: '',
    showCheckbox: false,
    position: 'bottom',
    autoPosition: false,
    disabled: false,
  };
  newTransaction = new FormArray([]); // For show loading, preview, and check is PDF only.
  showBankPayButton = false;
  showPayButton = false;
  selectedMerchantBank = [];
  buttonLoading = false;
  isBankTransactionActionBtnClicked = {}; // { idx: boolean }
  messages2$ = this.withdrawDataService.messages2$;

  isWPPSelected = false;

  isPaymentGatewaySelected = false;

  minAmountText = [];
  maxAmountText = [];
  showMinAmount = [];
  showMaxAmount = [];

  showTotalProcessingFeeError = [];
  totalProcessingFeeErrorText = [];
  showProcessingFeeError = [];
  processingFeeErrorText = [];
  showFeeBreakdownRequired = [];
  cryptoWithdrawalLink = '';
  cryptoWithdrawalLinkClicked = false;

  // Permissions
  canEditWithdrawals: boolean;
  canUploadWithdrawalReceipt: boolean;
  canViewWithdrawalAmount: boolean;
  canSyncPayoutTransaction: boolean;
  canVoidPayoutTransaction: boolean;
  canVoidPayoutTransactionBankTransfer: boolean;
  canVoidPayoutTransactionPG: boolean;
  canVoidPayoutTransactionOfflineBank: boolean;
  canRevertPayoutTransaction: boolean;
  canForceApproveTransaction: boolean;
  canManualResolvePayout: boolean;
  // Force Approve may skip the vendor callback check after a warning. Member withdrawals only.
  canBypassCallbackCheck: boolean;

  withdrawalStatus = 0;
  existAutoWithdrawRecord = false;
  existPendingAutoWithdrawRecord = false;

  // AIO-79217: matches Bank::CODE_BANK_OFFLINE on the API.
  readonly BANK_OFFLINE_CODE = 'BANK OFFLINE';

  // AIO-79217: Telegram resend cooldown, in seconds. Only the value the countdown STARTS at on click,
  // before the server has said anything. The API owns the window and returns retry_after (seconds still
  // to run) when it rejects an early resend, and onResendTelegram resyncs to that - so this drifting
  // from OfflinePayoutTelegramService::RESEND_COOLDOWN_SECONDS self-corrects on the next attempt.
  readonly RESEND_COOLDOWN_SECONDS = 60;
  resendCooldown: { [bankTransactionId: number]: number } = {};
  private resendTimers: { [bankTransactionId: number]: any } = {};

  private sum = 0;
  private touchedAmountSum = 0;
  private touchedAmountIndexes = [];
  private subscription: Subscription[] = [];
  private refreshWithdrawDialogSubscription?: Subscription;
  private isDestroyed = false;

  constructor(
    private fb: FormBuilder,
    private merchantBankDataService: MerchantBankDataService,
    private uploadService: UploadHttpService,
    private sanitizer: DomSanitizer,
    private lightbox: Lightbox,
    private withdrawDataService: WithdrawDataService,
    private withdrawEntityService: WithdrawEntityService,
    public dialog: MatDialog,
    private appPermissionService: AppPermissionService,
    private cdr: ChangeDetectorRef,
    private decimalPipe: DecimalPipe,
    private eventEmitterService: EventEmitterService,
  ) { }

  ngOnInit() {
    if (this.bankTransactions.length > 0) {
      this.existAutoWithdrawRecord = this.bankTransactions.some(
        x => x.approval_type === 1
      );
    }

    this.isPaymentGatewaySelected = this.withdrawalBankType == 'crypto' ? true : false;
    this.formInit();
    this.formChanged();
    if (this.merchantBanksSource$) {
      this.subscription.push(this.merchantBanksSource$.pipe(
        tap(res => {
          this.merchantBanks = this.sortMerchantBanksDesc((res || []).map((item: MerchantBank) => this.withWithdrawalLabel(item) as MerchantBank));
          this.refreshFilterMerchantBanks({ bankTransactions: this.bankTransactions });
        })
      ).subscribe());
    } else {
      this.subscription.push(this.getMerchantBanks().subscribe());
    }

    const apSub = this.appPermissionService.getAppPermissions().subscribe(appPermissions => {
      this.canEditWithdrawals = this.from === 'affiliate' ? appPermissions.edit_affiliate_withdrawal : (this.withdrawalBankType == 'crypto' ? appPermissions.edit_crypto_withdrawals : appPermissions.edit_withdrawals);
      this.canUploadWithdrawalReceipt = this.withdrawalBankType == 'crypto' ? false : appPermissions.upload_withdrawal_receipt;
      this.canViewWithdrawalAmount = this.withdrawalBankType == 'crypto' ? appPermissions.view_crypto_withdrawal_amount : appPermissions.view_banking_withdrawal_amount;
      this.canSyncPayoutTransaction = this.withdrawalBankType == 'crypto' ? false : appPermissions.sync_payout_transaction;
      this.canVoidPayoutTransactionBankTransfer = this.withdrawalBankType == 'crypto' ? false : appPermissions.void_payout_transaction_bank_transfer;
      this.canVoidPayoutTransactionPG = this.withdrawalBankType == 'crypto' ? false : appPermissions.void_payout_transaction_pg;
      this.canVoidPayoutTransactionOfflineBank = this.withdrawalBankType == 'crypto' ? false : appPermissions.void_payout_transaction_offline_bank;
      this.canRevertPayoutTransaction = this.withdrawalBankType == 'crypto' ? false : appPermissions.revert_payout_transaction;
      this.canForceApproveTransaction = this.withdrawalBankType == 'crypto' ? false : appPermissions.force_approve_payout_transaction;
      this.canManualResolvePayout = this.withdrawalBankType == 'crypto' ? false : appPermissions.manual_resolve_payout_transaction;
      this.canBypassCallbackCheck = this.canForceApproveTransaction && this.from === 'member';
      this.safeDetectChanges();
    });

    this.subscription.push(apSub);

    this.refreshWithdrawDialogSubscription = this.eventEmitterService.refreshWithdrawDialog.subscribe((res) => {
      this.refreshFilterMerchantBanks(res);
    });
  }

  ngOnDestroy() {
    this.isDestroyed = true;
    this.subscription.forEach(sub => sub?.unsubscribe());
    this.refreshWithdrawDialogSubscription?.unsubscribe();
    // AIO-79217: stop the resend countdowns so they do not keep ticking after the dialog closes.
    Object.keys(this.resendTimers).forEach(key => clearInterval(this.resendTimers[key]));
    this.resendTimers = {};
  }

  onAddTransaction() {
    if( this.merchantBanks.length <= 0 ) {
      return;
    }

    // Crypto can only have 1 instance
    let canAddTransaction = true;
    if( this.withdrawalBankType == 'crypto' ) {
      this.bankTransactions.forEach(item => {
        if (item.status == BankTransactionStatus.Pending) {
          canAddTransaction = false;
          this.cryptoWithdrawalLink = item.cr_withdrawal_link || '';

          if( this.banks.length <= 0 ) {
            const group = new FormGroup({
              id: new FormControl(item.id),
              amount: new FormControl(item.amount, [Validators.required, Validators.pattern('^(?=.*[1-9])[0-9]+(\.[0-9]+)?$')]),
              processing_fee: new FormControl(item.processing_fee, [Validators.min(0)]),
              remarks: new FormControl(item.remarks),
              receipt_image: new FormControl(item.receipt_image),
              payee_ifsc_code: new FormControl(null),
              total_processing_fee: new FormControl(0),
              member_processing_fee: new FormControl(0),
            });
            this.banks.push(group);
            this.selectedMerchantBank[this.banks.length - 1] = this.merchantBanks.filter(row => row.id === item.merchant_bank_id);
            this.autoCalculateSumAmount();
          }
          this.form.disable();
          this.bankaccountDropdownSettings = {...this.bankaccountDropdownSettings, disabled: true};
        }
      });
    }
    if( !canAddTransaction ) {
      return;
    }

    // Amount Part
    let finalAmount = this.confirmedAmount;
    this.bankTransactions.forEach(item => {
      if (item.status == BankTransactionStatus.Approved) {
        finalAmount -= +item.amount;
      }
    })
    this.banks.value.forEach(item => {
      finalAmount -= +item.amount;
    })
    // restrict 2 decimal places for amount value
    finalAmount = Number(Number(finalAmount.toString()).toFixed(2));
    const group = new FormGroup({
      id: new FormControl(null),
      amount: new FormControl(finalAmount, [Validators.required, Validators.pattern('^(?=.*[1-9])[0-9]+(\.[0-9]+)?$')]),
      processing_fee: new FormControl(0.00, [Validators.min(0)]),
      remarks: new FormControl(null), // add back for payout
      receipt_image: new FormControl(null),
      payee_ifsc_code: new FormControl(null),
      total_processing_fee: new FormControl(0),
      member_processing_fee: new FormControl(0),
    });
    this.banks.push(group);
    this.selectedMerchantBank[this.banks.length - 1] = [];
    this.autoCalculateSumAmount();

    // Receipt Part
    const transactionGroup = new FormGroup({
      loading: new FormControl(false),
      url: new FormControl(''),
      isPDF: new FormControl(false),
    });
    this.newTransaction.push(transactionGroup);
  }

  onRemoveItem(index: number) {
    this.newTransaction.removeAt(index);
    this.selectedMerchantBank.splice(index, 1);
    this.showPayButton = false;
    //pass value to withdrawal-edit component
    this.payButtonExist.emit(this.showPayButton);

    this.isWPPSelected = false;
    this.isPaymentGatewaySelected = false;
    this.selectedMerchantBank.forEach(item => {
      const selectedTarget = item[0];
      if (this.isPaymentGatewayTarget(selectedTarget)) {
        this.showPayButton = true;
        //pass value to withdrawal-edit component
        this.payButtonExist.emit(this.showPayButton);

        this.isPaymentGatewaySelected = true;
      } else {
        this.showPayButton = false;
        //pass value to withdrawal-edit component
        this.payButtonExist.emit(this.showPayButton);

        this.isPaymentGatewaySelected = false;
      }
      if (selectedTarget?.bank_code == 'WPP') {
        this.isWPPSelected = true;
      }
    })
    this.banks.removeAt(index);
    if (this.banks.controls.length === 0) {
      this.touchedAmountIndexes = [];
      this.touchedAmountSum = 0;
      this.sum = 0;
    }
    this.cryptoWithdrawalLink = '';
    this.form.enable();
    this.autoCalculateSumAmount();
  }

  onSelectMerchantBank(event: any, index: number) {
    this.selectedMerchantBank[index] = event;
    const selectedTarget = event?.[0];
    if (this.selectedMerchantBank[index].length > 0) {
      if (event[0].bot_status == 1 && event[0].purpose == 2 && event[0].auto_withdrawal == true) {
        this.showBankPayButton = true;
      } else {
        this.showBankPayButton = false;
      }
      // If cannot get the min_transaction_withdrawal_limit and max_transaction_withdrawal_limit, use merchant bank value instead
      const minWithdrawalLimit = event[0].min_transaction_withdrawal_limit ? event[0].min_transaction_withdrawal_limit : event[0].min_withdrawal_per_transaction;
      const maxWithdrawalLimit = event[0].max_transaction_withdrawal_limit ? event[0].max_transaction_withdrawal_limit : event[0].max_withdrawal_per_transaction;
      const currency = event[0].currency;
      this.determineAmountDisplay(+this.banks.value[index].amount, +minWithdrawalLimit, +maxWithdrawalLimit, index, currency);
    } else {
      this.showMinAmount[index] = false;
      this.showMaxAmount[index] = false;
    }
    if (this.isPaymentGatewayTarget(selectedTarget)) {
      this.showPayButton = true;
      //pass value to withdrawal-edit component
      this.payButtonExist.emit(this.showPayButton);

      this.isPaymentGatewaySelected = true;
      if (selectedTarget?.bank_code == 'WPP') {
        this.isWPPSelected = true;
      }
    } else {
      this.showPayButton = false;
      //pass value to withdrawal-edit component
      this.payButtonExist.emit(this.showPayButton);

      this.isPaymentGatewaySelected = false;
    }
    this.updateWithdrawalFeePreview(index);
  }

  determineAmountDisplay(amount: number, minWithdrawalLimit: number, maxWithdrawalLimit: number, index: number, currencyTxt: any) {
    const currency = currencyTxt;
    this.showMinAmount[index] = false;
    this.showMaxAmount[index] = false;

    // Always populate the limit texts so Minimum/Maximum can show under Amount once a bank is selected.
    this.minAmountText[index] = currency + ' ' + this.formatLimit(minWithdrawalLimit);
    this.maxAmountText[index] = maxWithdrawalLimit > 0
      ? currency + ' ' + this.formatLimit(maxWithdrawalLimit)
      : 'Unlimited';

    // Turn red only for the bound the amount violates (0 counts as below the minimum).
    if (minWithdrawalLimit > 0 && amount < minWithdrawalLimit) {
      this.showMinAmount[index] = true;
    }
    if (maxWithdrawalLimit > 0 && amount > maxWithdrawalLimit) {
      this.showMaxAmount[index] = true;
    }
  }

  // Whole numbers show no decimals (1,000); values with decimals show exactly 2 (100.50).
  private formatLimit(value: any): string {
    const n = Number(String(value).replace(/,/g, '')) || 0;
    return this.decimalPipe.transform(n, Number.isInteger(n) ? '1.0-0' : '1.2-2') ?? '';
  }

  private withWithdrawalLabel(item: any): any {
    const amountText = item?.daily_withdrawal_amount ?? '';
    const currency = item?.currency ?? '';
    const [usedStr, maxStr] = String(amountText).split('/');
    const used = parseFloat(String(usedStr).replace(/,/g, '')) || 0;
    const max = parseFloat(String(maxStr).replace(/,/g, '')) || 0;

    return {
      ...item,
      labelKey: item.bank_code + ' - ' + item.account_name + ' - ' + item.account_number,
      dailyWithdrawalValue: amountText ? `${currency} ${this.formatLimit(used)} / ${max > 0 ? this.formatLimit(max) : 'Unlimited'}` : '',
      dailyWithdrawalClass: this.getDailyLimitStatusClass(used, max),
    };
  }

  private getDailyLimitStatusClass(used: number, max: number): string {
    // No daily cap configured -> treat as within limit.
    if (max <= 0) {
      return 'text-success';
    }
    const percentage = (used / max) * 100;
    if (percentage >= 100) {
      return 'text-danger';   // Limit reached
    }
    if (percentage >= 50) {
      return 'text-warning';  // Near limit
    }
    return 'text-success';    // Within limit
  }

  onBankPay(index: number) {
    const errMessages = [
      this.processingFeeErrorText[index],
      this.totalProcessingFeeErrorText[index],
    ];

    if (this.showProcessingFeeError[index] || this.showTotalProcessingFeeError[index]) {
      Swal.fire({
        title: 'System Message',
        html: errMessages.filter(v => v).join('<br />'),
        icon: 'error',
        confirmButtonText: 'Ok',
      });
      return;
    }

    this.payoutBankTransaction2.emit({ payload: { index } });
  }

  onPay(index: number) {
    if (this.withdrawalBankType == 'crypto' && this.cryptoWithdrawalLink) {
      Swal.fire({
        title: 'Coin2Pay Withdrawal Link has been generated and clicked before!',
        text: 'Do you want to generate a new link?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          this.createPayout(index, true);
        }
      });
    } else {
      this.createPayout(index);
    }
    return;
  }

  createPayout(index, isRegenerate? :boolean) {
    if (this.delegatePayout || this.withdrawalBankType != 'crypto') {
      this.payoutBankTransaction.emit({ payload: { index } });
      return;
    }

    if (this.withdrawalBankType == 'crypto') {
      this.bankaccountDropdownSettings = {...this.bankaccountDropdownSettings, disabled: true};
    }

    this.buttonLoading = true;
    this.form.disable();
    const selectedTarget = this.selectedMerchantBank[index]?.[0] ?? {};
    const data: any = {
      withdraw_id: this.id,
      amount: this.form.value.merchant_banks[index].amount,
      member_account_id: this.withdrawalDetails.member_id,
      bank_account_id: this.withdrawalDetails.bank_account_id,
      merchant_bank_id: selectedTarget.id,
      payment_account_id: selectedTarget.payment_account_id,
      payment_gateway_config_id: selectedTarget.payment_gateway_config_id,
      payee_ifsc_code: this.form.value.merchant_banks[index].payee_ifsc_code,
      is_crypto: this.withdrawalBankType == 'crypto' ? 1 : 0
    };
    if( isRegenerate ) {
      data.bank_transaction_id = this.bankTransactions[index].id;
    }
    Object.keys(data).forEach((key) => (data[key] == null || data[key] === '') && delete data[key]);
    this.withdrawDataService.createPayout(data).pipe(
      tap((res: any) => {
        this.buttonLoading = false;
        this.update.emit(this.form.value);
        if (this.withdrawalBankType == 'crypto') {
          if( res.rows && res.rows.data && res.rows.data.url ) {
            this.cryptoWithdrawalLink = res.rows.data.url || '';
            this.cryptoWithdrawalLinkClicked = false;
          }
        } else {
          this.onRemoveItem(index);
          this.form.enable();
        }
      }),
      catchError((error) => {
        this.form.enable();
        this.buttonLoading = false;
        if (this.withdrawalBankType == 'crypto') {
          this.bankaccountDropdownSettings = {...this.bankaccountDropdownSettings, disabled: false};
        }
        throw error;
      })
    ).subscribe();
  }

  onApproveBankTransaction(index: number) {
    const errMessages = [
      this.processingFeeErrorText[index],
      this.totalProcessingFeeErrorText[index],
    ];

    if (this.showProcessingFeeError[index] || this.showTotalProcessingFeeError[index]) {
      Swal.fire({
        title: 'System Message',
        html: errMessages.filter(v => v).join('<br />'),
        icon: 'error',
        confirmButtonText: 'Ok',
      });
      return;
    }

    this.approveBankTransaction.emit({ payload: { index, } });
  }

  onRedirectCryptoWithdrawalUrl() {
    this.cryptoWithdrawalLinkClicked = true;
    window.open(this.cryptoWithdrawalLink, '_blank').focus();
  }

  onCheckPayoutStatus(bankTransaction: any, index: number, banksysId: number) {
    this.isBankTransactionActionBtnClicked[index] = true;
    
    // AIO-82573: the Pending branch used to call getById, which refreshes CMS from CMS and never
    // asks banksys — so the button labelled "Sync" did not sync. It goes to syncBankPayout, which
    // reads banksys and applies the answer to CMS without writing to banksys at all.
    //
    // NOT retryBankPayout: that writes the withdrawal back to PENDING to re-queue it. On a Pending
    // row whose transfer may already have gone out, a button labelled "Sync" doing that is how the
    // same withdrawal gets sent twice. Rejected rows keep Retry, which is what that button means
    // there.
    const request$ = banksysId != null
    ? (bankTransaction.status === this.BankTransactionStatusEnum.Pending
        ? this.withdrawDataService.syncBankPayout(bankTransaction.id)
        : this.withdrawDataService.retryBankPayout(bankTransaction.id))
    : this.withdrawDataService.getPayoutStatus(bankTransaction.id);

    request$
      .pipe(
        catchError(err => {
          // Handle the error
          throw err;
        }),
        finalize(() => {
          // Always reset button state
          this.isBankTransactionActionBtnClicked[index] = false;
        })
      )
      .subscribe(res => {
        if (banksysId != null && bankTransaction.status === this.BankTransactionStatusEnum.Pending) {
          this.bankTransactions = res['bank_transactions'];
          this.cdr.detectChanges();
          this.eventEmitterService.onRefreshWithdrawal();
        }

        this.refreshFilterMerchantBanks({'bankTransactions': res['bank_transactions']});
        this.updateWithdraw.emit(res);
      });
  }

  /**
   * Turn the bot's raw state into something an operator can read. (AIO-82573)
   *
   * Eleven engineering states are not a UI, so they collapse into six buckets. The raw value and
   * its timestamp stay in the tooltip, for whoever is debugging rather than operating.
   */
  botStateLabel(botState: string): string {
    switch (botState) {
      case 'queued':
        return 'Waiting for bot';
      case 'awaiting_login_tac':
      case 'awaiting_transfer_tac':
      case 'awaiting_approval_tac':
        return 'Needs your TAC';
      case 'login':
      case 'validating_recipient':
      case 'submitting':
      case 'checker_login':
      case 'approving':
        return 'Processing';
      case 'booked':
        return 'Awaiting checker approval';
      case 'needs_verification':
      case 'bank_unreachable':
      case 'session_lost':
        return 'Needs checking';
      case 'invalid_account':
        return 'Invalid bank account';
      case 'rejected_by_bank':
      case 'failed':
        return 'Failed';
      case 'done':
        return 'Done';
      default:
        return botState;
    }
  }

  /**
   * Amber is the only colour that asks the operator for anything. (AIO-82573)
   * If everything looks urgent, nothing does — so this is deliberately just the three states the
   * bot writes when it has stopped and cannot say what happened.
   */
  botStateNeedsAttention(botState: string): boolean {
    return ['needs_verification', 'bank_unreachable', 'session_lost'].indexOf(botState) !== -1;
  }

  /**
   * The tooltip an operator reads, not the raw state. (AIO-82573)
   *
   * `bank_unreachable since 2026-09-25 14:58` is the engineer's version of this: it names the
   * constant, not the situation, and says nothing about what to do next. The three give-up states
   * end with the action, because those are the only ones asking the operator for anything.
   */
  /**
   * Is the withdrawal itself already finished? (AIO-82573)
   *
   * Once it is Approved or Rejected its bank transactions are history, and acting on one of them
   * does not undo or redo the decision — it only decrements the merchant bank again for money that
   * never moved. The Sync button has always carried this condition; Reject and Mark as success now
   * carry it too. The server enforces it as well, since a hidden button is not a control.
   */
  get isWithdrawSettled(): boolean {
    return this.withdrawalStatus === this.WithdrawStatusEnum.Approved
      || this.withdrawalStatus === this.WithdrawStatusEnum.Rejected;
  }

  /**
   * Mark bot_state_at as UTC before it reaches the timezoneDate pipe. (AIO-82573)
   *
   * Every other timestamp in this dialog comes from a CMS model and arrives ISO-8601
   * ("2026-09-25T14:58:00.000000Z"), which new Date() reads as UTC. bot_state_at comes from banksys
   * through a query-builder select, so it arrives naive ("2026-09-25 14:58:00") — and Chrome reads
   * a space-separated string as LOCAL time. The pipe then subtracts the client offset from a value
   * that was never UTC, so the tooltip drifts by the browser's offset while created_at beside it is
   * right. (Safari does not parse that form at all and renders "Invalid date".)
   *
   * banksys runs on UTC, so stamping the marker here is the same statement the other timestamps
   * already carry. Done at the call site rather than in TimezoneDatePipe, which every other screen
   * relies on and which already handles ISO input correctly.
   */
  botStateSince(value: string): string {
    if (!value || value.indexOf('T') !== -1 || value.endsWith('Z')) {
      return value;
    }

    return value.replace(' ', 'T') + 'Z';
  }

  botStateTooltip(botState: string, since: string, banksysStatus?: number): string {
    // What the operator has to do differs by phase, and the phase is the banksys status: 3 is the
    // maker, 6 the checker. Without it the advice was "check RHB Reflex" with no way to know whose
    // session to check it from — and at the maker stage it also promised Mark as success, which is
    // not offered there, because a maker submission is only booked and has not paid anyone.
    const giveUpAdvice = banksysStatus === 3
      ? ' Log in with the MAKER account and check RHB Reflex. If a transfer request was created, delete it there, then Reject.'
      : (banksysStatus === 6
        ? ' Log in with the CHECKER account and check RHB Reflex, then Reject or Mark as success.'
        : ' Check RHB Reflex, then Reject or Mark as success.');

    const hints: { [key: string]: string } = {
      queued: 'Waiting for the bank bot to pick this up.',
      login: 'The bot is logging in to RHB Reflex.',
      awaiting_login_tac: 'The bot is waiting for the login TAC.',
      validating_recipient: 'The bot is checking the recipient account at the bank.',
      awaiting_transfer_tac: 'The bot is waiting for the TAC that releases the transfer.',
      submitting: 'The bot is submitting the transfer to the bank.',
      booked: 'Submitted by the maker. Waiting for the checker to approve it.',
      checker_login: 'The checker session is logging in.',
      awaiting_approval_tac: 'The bot is waiting for the TAC that releases the approval.',
      approving: 'The checker is approving the transfer.',
      needs_verification: 'The bot did not get a reply from the bank, so it cannot tell whether the transfer went out.' + giveUpAdvice,
      bank_unreachable: 'The bot could not reach RHB Reflex.' + giveUpAdvice,
      session_lost: 'The bot was logged out and could not log back in on its own.' + giveUpAdvice,
      invalid_account: 'The bank rejected the recipient account number.',
      rejected_by_bank: 'The bank rejected this transfer.',
      failed: 'The bot could not complete this transfer.',
      done: 'Completed by the bot.'
    };

    const hint = hints[botState] || botState;

    return since ? hint + '\nSince ' + since : hint;
  }

  /**
   * Escape a value before it goes into a SweetAlert `html` body. (AIO-82573)
   *
   * account_name and account_number are supplied by the member at registration, so they are
   * attacker-controlled: interpolated raw, a name like `<img src=x onerror=...>` runs script in the
   * operator's browser the moment the confirmation opens.
   */
  private escapeHtml(value: any): string {
    if (value === null || value === undefined) {
      return '';
    }

    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  /**
   * Stop an auto-withdrawal the bank bot has not completed. (AIO-82573)
   *
   * The confirmation carries the whole safety burden: the operator is asserting they checked the
   * bank portal and found nothing. banksys re-checks and refuses if the bot is still live, so a
   * mistaken click loses cleanly rather than cancelling a transfer that is on its way.
   */
  onRejectBankPayout(bankTransaction: any, index: number) {
    Swal.fire({
      icon: 'warning',
      title: 'Reject this auto-withdrawal?',
      html: `<div style="text-align:left">`
        + `<p><b>RM ${this.escapeHtml(bankTransaction.amount)}</b> &middot; transaction #${this.escapeHtml(bankTransaction.id)}<br>`
        + `<span style="color:#74788d">${this.escapeHtml(bankTransaction.merchant_bank_account)}</span></p>`
        + `<p>Please confirm you have checked RHB Reflex and there is <b>no transaction</b> for this withdrawal.</p>`
        + `<p>This stops the bank bot from processing it and rejects this bank transaction here. It does not reverse a transfer that has already been sent.</p>`
        + `<p style="color:#9a4708"><b>If the maker already created a transfer request in RHB Reflex, delete it there yourself.</b> `
        + `Rejecting here does not remove it from the bank — a request left in Pending Approval can still be approved by a checker and pay out.</p>`
        + `</div>`,
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonText: 'Confirm reject',
    }).then(result => {
      if (!result.value) {
        return;
      }

      this.isBankTransactionActionBtnClicked[index] = true;

      this.withdrawDataService.rejectBankPayout(bankTransaction.id)
        .pipe(
          catchError(err => { throw err; }),
          finalize(() => { this.isBankTransactionActionBtnClicked[index] = false; })
        )
        .subscribe(res => {
          this.bankTransactions = res['bank_transactions'];
          this.cdr.detectChanges();
          this.eventEmitterService.onRefreshWithdrawal();
          this.updateWithdraw.emit(res);
        });
    });
  }

  /**
   * Record that a transfer the bot did not complete was in fact paid. (AIO-82573)
   *
   * Asks for the bank's reference and a receipt, because the bot captured none on this path — the
   * operator's upload becomes the audit artifact that replaces it. Both are required by banksys
   * too; the prompt only saves a round trip.
   *
   * One dialog, built the same way as the offline-approve one above: the native file input cannot
   * be styled, so it is hidden and its <label> is the clickable box (#swal2-content .offline-receipt-
   * dropzone in styles.scss). The upload runs inside preConfirm, so a failed upload leaves the
   * dialog open with the reference still typed rather than dropping the operator back to the table.
   */
  onMarkBankPayoutSuccess(bankTransaction: any, index: number) {
    Swal.fire({
      icon: 'warning',
      title: 'Mark as success?',
      html: `<div style="text-align:left">`
        + `<p><b>RM ${this.escapeHtml(bankTransaction.amount)}</b> &middot; transaction #${this.escapeHtml(bankTransaction.id)}<br>`
        + `<span style="color:#74788d">${this.escapeHtml(bankTransaction.merchant_bank_account)}</span></p>`
        + `<p>Confirm this transfer was <b>actually paid out</b> from RHB Reflex.</p>`
        + `<p>This marks the withdrawal successful and approves it here. It does not send any money.</p>`
        + `<p style="color: red; margin: 1rem 0 0;">Bank Reference Number</p>`
        + `<input id="mark-success-reference-input" class="form-control" maxlength="100">`
        + `<p style="color: red; margin: 1rem 0 0;">Receipt</p>`
        // Bootstrap utilities do the whole box: .form-control is the field, d-flex/align-items-center/
        // justify-content-center centre it, mb-0 drops the label's margin, mr-2 spaces the icon and
        // text-truncate ellipsises a long filename. Only cursor:pointer has no BS4 utility, so it is
        // the one inline declaration. .d-none hides the native input, whose "Choose File" button
        // cannot be styled at all — the label is what the operator clicks.
        + `<label class="form-control d-flex align-items-center justify-content-center mb-0" style="cursor: pointer" for="mark-success-receipt-input">`
        + `<i class="fas fa-upload text-primary mr-2"></i>`
        + `<span id="mark-success-receipt-name" class="text-truncate" style="min-width: 0">Upload Receipt</span>`
        + `</label>`
        + `<input id="mark-success-receipt-input" class="d-none" type="file" accept="image/*, application/pdf">`
        + `</div>`,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      showCancelButton: true,
      confirmButtonText: 'Confirm success',
      cancelButtonText: 'Cancel',
      reverseButtons: true,
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
      didOpen: () => {
        const fileInput = document.getElementById('mark-success-receipt-input') as HTMLInputElement;
        const fileName = document.getElementById('mark-success-receipt-name');
        if (!fileInput || !fileName) {
          return;
        }

        fileInput.addEventListener('change', () => {
          fileName.textContent = fileInput.files?.[0]?.name ?? 'Upload Receipt';
        });
      },
      preConfirm: () => {
        const reference = (document.getElementById('mark-success-reference-input') as HTMLInputElement)?.value ?? '';

        if (reference.trim() === '') {
          Swal.showValidationMessage('Bank reference number is required.');
          return false;
        }

        const file = (document.getElementById('mark-success-receipt-input') as HTMLInputElement)?.files?.[0];

        if (!file) {
          Swal.showValidationMessage('Receipt is required.');
          return false;
        }

        // Upload first and send the URL, exactly as onUploadFile() does for the ordinary receipt
        // flow. receipt_image is a 250-character URL column on both sides — sending the file
        // inline as a data URI would overflow it, and the audit receipt would be truncated or
        // rejected outright.
        const formData = new FormData();
        formData.append('files', file, file.name);
        formData.append('type', 'receipts');

        return this.uploadService.upload(formData).toPromise().then((res: any) => {
          // No URL back means no receipt. Going ahead would show the operator a success while the
          // only audit artifact on this path silently went missing.
          if (!res || !res.length || !res[0]) {
            Swal.showValidationMessage('Failed to upload receipt.');
            return false;
          }

          return { reference_no: reference.trim(), receipt_image: res[0] };
        }).catch(() => {
          Swal.showValidationMessage('Failed to upload receipt.');
          return false;
        });
      }
    }).then(result => {
      // preConfirm resolves with the uploaded payload, or false when it showed a validation
      // message — so the shape has to be checked, not just its truthiness.
      const payload = result.value as { reference_no: string, receipt_image: string } | undefined;

      if (!payload || !payload.receipt_image) {
        return;
      }

      this.isBankTransactionActionBtnClicked[index] = true;

      this.withdrawDataService.markBankPayoutSuccess(bankTransaction.id, {
        reference_no: payload.reference_no,
        receipt_image: payload.receipt_image,
      })
        .pipe(
          catchError(err => { throw err; }),
          finalize(() => { this.isBankTransactionActionBtnClicked[index] = false; })
        )
        .subscribe(res => {
          this.bankTransactions = res['bank_transactions'];
          this.cdr.detectChanges();
          this.eventEmitterService.onRefreshWithdrawal();
          this.updateWithdraw.emit(res);
        });
    });
  }

  async onUpdateBankTransactionStatus(bankTransactionId: number, index: number, type: 'revert' | 'void' | 'approve' | 'force-approve' | 'manual-approve' | 'manual-reject' | 'offline-approve' | 'offline-reject') {
    this.isBankTransactionActionBtnClicked[index] = true;

    // force approve
    // check latest callback status before proceed
    // Without a success callback the operator may still approve after a warning - the API then skips
    // its own callback check (bypass_callback_check) and alerts Telegram.
    let bypassCallbackCheck = false;

    if( type == 'force-approve' ) {
      let callbackSucceeded = false;

      try {
        const res = await this.withdrawDataService.getCallbackStatus(bankTransactionId).toPromise();
        // A payload without a status is treated as not successful, so it reaches the warning, never a silent stop.
        callbackSucceeded = !!res && res.status === true;
      } catch (err) {
        // The global interceptor already shows the error (and logs out on 403). The vendor status is
        // unknown, so never offer the bypass - the operator retries once the check works again.
        this.isBankTransactionActionBtnClicked[index] = false;
        return;
      }

      if (!callbackSucceeded) {
        if (!this.canBypassCallbackCheck) {
          Swal.fire({
            icon: 'error',
            title: 'Unable To Approve Payout',
            text: 'The latest callback status indicates a different status. Please verify with the payment vendor before proceeding.',
          });
          this.isBankTransactionActionBtnClicked[index] = false;
          return;
        }

        const warning = await Swal.fire({
          icon: 'warning',
          title: 'Vendor Callback Not Successful',
          html: 'The latest payment vendor callback does not show this payout as successful.'
            + '<br><br>Approving will mark it as <b>paid</b> and deduct the gateway balance.'
            + '<br><br>Only proceed if you have <b>confirmed with the vendor that the payout succeeded</b>.',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          showCancelButton: true,
          confirmButtonText: 'Proceed',
          cancelButtonText: 'Cancel',
          reverseButtons: true,
        });

        if (!warning.value) {
          this.isBankTransactionActionBtnClicked[index] = false;
          return;
        }

        bypassCallbackCheck = true;
      }
    }
    
    let swalTitle: string;
    let swalText: string;
    let remarksRequired = true;
    let status: BankTransactionStatus;

    if (type == 'revert') {
      swalTitle = 'Revert Payout Status';
      swalText = "Do you want to revert this payout status to <b>'Pending'</b>?";
      status = BankTransactionStatus.Pending;
    }

    if (type == 'void') {
      swalTitle = 'Void Approved Payout';
      swalText = "Do you want to reject this bank transaction?";
      status = BankTransactionStatus.Rejected;
    }

    if (type === 'force-approve' && bypassCallbackCheck) {
      swalTitle = 'Force Approve Rejected Payout';
      swalText = 'Do you want to mark this rejected payout as <b>approved</b>?';
      status = BankTransactionStatus.Approved;
    } else if (type == 'approve' || type == 'force-approve') {
      swalTitle = 'Approve Payout';
      swalText = "Do you want to approve this bank transaction?";
      status = BankTransactionStatus.Approved;
    }

    // AIO-78767 — resolving a payout that never received a gateway callback. Deliberately skips the
    // getCallbackStatus() pre-check above: by definition there is no callback to verify against, so
    // the operator's remark is the only justification on record.
    if (type == 'manual-approve') {
      swalTitle = 'Manually Approve Timed-Out Payout';
      swalText = "No callback was received from the payment vendor for this payout."
        + "<br><br>Only approve if you have <b>confirmed with the vendor that the payout succeeded</b>."
        + "<br><br>Do you want to mark this payout as <b>approved</b>?";
      status = BankTransactionStatus.Approved;
    }

    if (type == 'manual-reject') {
      swalTitle = 'Manually Reject Timed-Out Payout';
      swalText = "No callback was received from the payment vendor for this payout."
        + "<br><br>Only reject if you have <b>confirmed with the vendor that the payout did not succeed</b>."
        + "<br><br>Do you want to mark this payout as <b>rejected</b>?";
      status = BankTransactionStatus.Rejected;
    }

    // AIO-79217: Bank (Offline) has no gateway callback - a PIC pays it by hand from the Telegram
    // group, so the operator settles the pending payout here. Approve requires a receipt; it is the
    // only proof the transfer happened.
    const isOfflineApprove = type == 'offline-approve';

    if (isOfflineApprove) {
      swalTitle = 'Approve Offline Payout';
      swalText = "Do you want to approve this offline bank payout?";
      status = BankTransactionStatus.Approved;
    }

    if (type == 'offline-reject') {
      swalTitle = 'Reject Offline Payout';
      swalText = "Do you want to reject this offline bank payout?";
      status = BankTransactionStatus.Rejected;
    }

    // The native file input cannot carry the dropzone look and its button cannot be styled at all,
    // so it is hidden and its <label> becomes the clickable box. The label keeps .form-control, which
    // is what makes it the same box as the remark field below - see
    // #swal2-content .offline-receipt-dropzone in styles.scss.
    const receiptHtml = isOfflineApprove
      ? `<p style="color: red; margin: 1rem 0 0;">Receipt</p>` +
        `<label class="form-control offline-receipt-dropzone" for="receipt-input">` +
        `<i class="fas fa-upload text-primary"></i>` +
        `<span id="receipt-name">Upload Receipt</span>` +
        `</label>` +
        `<input id="receipt-input" type="file" accept="image/*, application/pdf">`
      : '';

    let remarksHtml = `<p style="color: ${remarksRequired ? 'red' : 'inherit'}; margin: 1rem 0 0;">Remark${remarksRequired ? '' : ' (Optional)'}</p></div><input id="remark-input" class="form-control">`;

    const data: { remarks: string; status: BankTransactionStatus; receipt_image?: string; bypass_callback_check?: boolean } = {
      remarks: '',
      status,
    };

    if (bypassCallbackCheck) {
      data.bypass_callback_check = true;
    }

    Swal.fire({
      title: swalTitle,
      html: '<div style="text-align: center;">' + receiptHtml + remarksHtml + '<p style="margin-top: 20px;">' + swalText + '</p></div>',
      icon: 'info',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      reverseButtons: true,
      // AIO-79217: the offline approve uploads the receipt inside preConfirm, so keep the dialog
      // showing a loader and non-dismissable while that request is in flight.
      showLoaderOnConfirm: isOfflineApprove,
      allowOutsideClick: () => !Swal.isLoading(),
      didOpen: () => {
        const fileInput = document.getElementById('receipt-input') as HTMLInputElement;
        const fileName = document.getElementById('receipt-name');
        if (!fileInput || !fileName) {
          return;
        }

        // With the real input hidden the dropzone is the operator's only feedback, so it has to name
        // the picked file - otherwise a cancelled picker looks exactly like a chosen receipt, on the
        // one field that is mandatory.
        fileInput.addEventListener('change', () => {
          fileName.textContent = fileInput.files?.[0]?.name ?? 'Upload Receipt';
        });
      },
      preConfirm: () => {
        const inputValue = (document.getElementById('remark-input') as HTMLInputElement)?.value ?? '';

        if (inputValue.trim() === '' && remarksRequired) {
          Swal.showValidationMessage('Remarks is required.');
          return false;
        }

        if (inputValue != '') {
          data.remarks = inputValue;
        }

        if (!isOfflineApprove) {
          return true;
        }

        const file = (document.getElementById('receipt-input') as HTMLInputElement)?.files?.[0];
        if (!file) {
          Swal.showValidationMessage('Receipt is required.');
          return false;
        }

        // Upload first so the approve call carries a path, matching how api/bo/withdraw takes a
        // receipt. If the upload fails the dialog stays open and nothing is approved.
        const formData = new FormData();
        formData.append('files', file, file.name);
        formData.append('type', 'receipts');

        return this.uploadService.upload(formData).toPromise().then((res: any) => {
          data.receipt_image = res[0];
          return true;
        }).catch(() => {
          Swal.showValidationMessage('Failed to upload receipt.');
          return false;
        });
      }
    }).then((resp) => {
      if (resp.value) {
        this.withdrawDataService.updateBankTransaction(bankTransactionId, data)
          .pipe(
            tap((res) => {
              this.updateWithdraw.emit(res);
              this.isBankTransactionActionBtnClicked[index] = false;
            }),
            catchError((err) => {
              this.isBankTransactionActionBtnClicked[index] = false;
              throw err;
            })
          )
          .subscribe();

      } else {
        this.isBankTransactionActionBtnClicked[index] = false;
      }
    });
  }

  /**
   * AIO-79217: is this payout row a Bank (Offline) one?
   *
   * Driven by the is_offline_bank flag the API returns - never by the bank name, which operators can
   * rename.
   */
  isOfflinePayout(row: any): boolean {
    return !!row && (+row.is_offline_bank === 1);
  }

  /**
   * AIO-79217: the Telegram send is best-effort - if the group never got the message the payout is
   * stuck with nobody to pay it, so give the operator a way to try again.
   *
   * The cooldown starts on click rather than on the response: the point is to stop the button being
   * hammered, and a failing group is exactly when an operator is most tempted to. The API enforces
   * the same window server-side, so this is a hint, not the protection.
   */
  onResendTelegram(bankTransactionId: number, index: number) {
    if (this.isResendOnCooldown(bankTransactionId)) {
      return;
    }

    this.isBankTransactionActionBtnClicked[index] = true;
    this.startResendCooldown(bankTransactionId);

    this.withdrawDataService.resendPayoutTelegram(bankTransactionId).pipe(
      tap((res: any) => {
        this.isBankTransactionActionBtnClicked[index] = false;
        this.updateWithdraw.emit(res);
      }),
      catchError((err) => {
        this.isBankTransactionActionBtnClicked[index] = false;

        // The API is the authority on the window: it answers an early resend with retry_after, the
        // seconds still to run. Resync from it rather than leaving the click-started 60 in place - this
        // branch is reached precisely when the dialog was reopened and the local timer was lost, so the
        // countdown on screen would otherwise be longer than the operator actually has to wait.
        // ApiErrorInterceptor rethrows the parsed body, so the field sits on err directly.
        const retryAfter = Number(err?.retry_after);
        if (retryAfter > 0) {
          this.startResendCooldown(bankTransactionId, retryAfter);
        }

        throw err;
      })
    ).subscribe();
  }

  isResendOnCooldown(bankTransactionId: number): boolean {
    return this.resendCooldownRemaining(bankTransactionId) > 0;
  }

  resendCooldownRemaining(bankTransactionId: number): number {
    return this.resendCooldown[bankTransactionId] ?? 0;
  }

  resendTooltip(row: any, index?: number): string {
    // In flight: the cooldown has already started, but saying "please wait 60 seconds" here would read
    // as a rate limit when the send is simply still running.
    if (index !== undefined && this.isBankTransactionActionBtnClicked[index]) {
      return 'Sending...';
    }

    if (this.isResendOnCooldown(row.id)) {
      return `Please wait ${this.resendCooldownRemaining(row.id)} seconds before resending`;
    }

    return row.telegram_error ? row.telegram_error : 'Telegram not sent - resend';
  }

  /**
   * Keyed by bank transaction id, not row index: the payout table is re-rendered from a fresh array
   * after every action, so an index-keyed timer would follow the wrong row.
   */
  private startResendCooldown(bankTransactionId: number, seconds: number = this.RESEND_COOLDOWN_SECONDS) {
    this.clearResendCooldown(bankTransactionId);
    this.resendCooldown[bankTransactionId] = seconds;

    this.resendTimers[bankTransactionId] = setInterval(() => {
      this.resendCooldown[bankTransactionId] -= 1;
      if (this.resendCooldown[bankTransactionId] <= 0) {
        this.clearResendCooldown(bankTransactionId);
      }
    }, 1000);
  }

  private clearResendCooldown(bankTransactionId: number) {
    if (this.resendTimers[bankTransactionId]) {
      clearInterval(this.resendTimers[bankTransactionId]);
      delete this.resendTimers[bankTransactionId];
    }
    delete this.resendCooldown[bankTransactionId];
  }

  onChangeAmount(event: Event, index: number) {
    const amount = +(event.target as HTMLInputElement).value;
    const merchantBank = this.selectedMerchantBank[index];
    if (merchantBank.length > 0) {
      // If cannot get the min_transaction_withdrawal_limit and max_transaction_withdrawal_limit, use merchant bank value instead
      const minWithdrawalLimit = merchantBank[0].min_transaction_withdrawal_limit ? merchantBank[0].min_transaction_withdrawal_limit : merchantBank[0].min_withdrawal_per_transaction;
      const maxWithdrawalLimit = merchantBank[0].max_transaction_withdrawal_limit ? merchantBank[0].max_transaction_withdrawal_limit : merchantBank[0].max_withdrawal_per_transaction;
      const currency = merchantBank[0].currency;
      this.determineAmountDisplay(amount, +minWithdrawalLimit, +maxWithdrawalLimit, index, currency);
    } else {
      this.showMinAmount[index] = false;
      this.showMaxAmount[index] = false;
    }
    this.touchedAmountIndexes.push(index);
    this.touchedAmountIndexes = [...new Set(this.touchedAmountIndexes)];
    this.autoCalculateSumAmount();
    this.updateWithdrawalFeePreview(index);
  }

  // Bank-transfer withdrawal fee is operator-EDITABLE. This prefills the 7.1 config default into the
  // (editable) fee fields when the bank is selected or the amount changes. Per AC4, changing the amount
  // re-pulls the config default and intentionally overwrites any prior manual edit (product decision).
  // The operator's final entered value is what gets submitted and charged (backend trusts it).
  private updateWithdrawalFeePreview(index: number) {
    const target = this.selectedMerchantBank[index]?.[0];
    const control = this.banks.controls[index];
    if (!target || !control || !this.isBankTransferTarget(target)) {
      return;
    }
    const amount = +this.banks.value[index].amount;
    if (!target.id || !amount) {
      return;
    }
    this.withdrawDataService.getProcessingFeePreview(target.id, amount).subscribe((res: any) => {
      control.patchValue({
        total_processing_fee: res.total_processing_fee,
        processing_fee: res.processing_fee,
        member_processing_fee: res.member_processing_fee,
      });
      this.validateProcessingFee(index);
    });
  }

  checkIfPDF(src: string) {
    return src.indexOf('.pdf') >= 0;
  }

  formatPDFSrc(src: string) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(src);
  }

  onOpenDialog(type: string, id?: number) {
    if (id) {
      if (type === 'show-remarks') {
        this.openDialogBy(ShowRemarkHistoryComponent, { mode: type, id, remarkType: 'bank-transaction' });
      }
    }
  }

  private openDialogBy(componentRef: any, data?: { id?: any, mode?: any, remarkType?: any }, dimension?: string) {
    const dialogRef = this.dialog.open(componentRef, {
      width: dimension ? dimension : '800px',
      height: 'auto',
      data: {
        id: data.id,
        remarkType: data.remarkType
      },
      autoFocus: data.mode === false
    });

    dialogRef.afterClosed().subscribe((result) => {});
    return dialogRef;
  }

  onUploadFile(event: any, index: number) {
    this.newTransaction.value[index].loading = true;
    const file: File = event.target.files[0];
    const formData = new FormData();
    formData.append('files', file, file.name);
    formData.append('type', 'receipts');
    this.uploadService.upload(formData).pipe(
      tap((res: any) => {
        this.newTransaction.value[index].isPDF = res[0].indexOf('.pdf') >= 0;
        this.newTransaction.value[index].url = res[0].indexOf('.pdf') >= 0 ? this.sanitizer.bypassSecurityTrustResourceUrl(res[0]) : res[0];
        this.form.value.merchant_banks[index].receipt_image = res[0];
        this.form.setValue({
          ...this.form.value
        });
        this.form.markAllAsTouched();
        this.newTransaction.value[index].loading = false;
      }),
      catchError(err => {
        this.newTransaction.value[index].loading = false;
        throw err;
      })
    ).subscribe();
  }

  openReceipt(path: any) {
    if (path.indexOf('.pdf') >= 0) {
      this.dialog.open(PdfDialogComponent, {
        width: '800px',
        data: {
          pdfSrc: path
        },
      });
    } else {
      const receipt = [{
        src: path,
        caption: 'Withdraw Receipt',
        thumb: path
      }];

      this.lightbox.open(receipt, 0, { centerVertically: true, disableScrolling: true, fitImageInViewPort: true, fadeDuration: 0.01, resizeDuration: 0.01 });
    }
  }

  onRemoveReceipt(index: number) {
    this.form.value.merchant_banks[index].receipt_image = null;
    this.newTransaction.value[index].url = '';
  }

  private autoCalculateSumAmount() {

    // Reset
    this.sum = 0;
    this.touchedAmountSum = 0;
    let balancer = 0;

    // Auto calculate
    this.banks.controls.forEach((control, index) => {

      const amount = +control.value[`amount`];
      if (amount !== null) {
        this.sum += amount;
      }

      if (this.isControlTouched(index)) {
        this.touchedAmountSum += amount;
      } else {
        balancer = +((this.confirmedAmount - this.touchedAmountSum) / +(this.banks.controls.length - this.touchedAmountIndexes.length)).toFixed(5);
        if (balancer <= 0 || this.touchedAmountSum >= this.confirmedAmount) {
          balancer = 0;
          control.patchValue({ amount: balancer });
        }
      }

    });
  }

  private isControlTouched(index: number) {
    return this.touchedAmountIndexes.includes(index);
  }

  private formChanged() {
    this.subscription.push(this.form.valueChanges.pipe(
      tap(() => this.changed.emit(this.buildPayload()))
    ).subscribe());

  }

  private buildPayload(): WithdrawMultiBankTransaction {
    const merchant_banks = this.form.value.merchant_banks.map((bank, index) => {
      const selectedTarget = this.selectedMerchantBank[index]?.[0] ?? {};

      return {
        ...bank,
        merchant_bank_id: selectedTarget.id ?? bank.id,
        payment_account_id: selectedTarget.payment_account_id,
        payment_gateway_config_id: selectedTarget.payment_gateway_config_id,
        min_withdrawal_per_transaction: selectedTarget.min_transaction_withdrawal_limit ?? selectedTarget.min_withdrawal_per_transaction,
        max_withdrawal_per_transaction: selectedTarget.max_transaction_withdrawal_limit ?? selectedTarget.max_withdrawal_per_transaction,
      };
    });

    return {
      ...this.form.value,
      merchant_banks,
    };
  }

  // Refresh the merchant-bank dropdown after a transaction is submitted. The parent passes the
  // latest accounts fetched from /merchantbank/v2 (same source as the initial load) so the daily
  // "Used" amount and the over-limit exclusion update. Falls back to the legacy fetch if none passed.
  refreshMerchantBanks(merchantBankAccounts?: any[]) {
    if (merchantBankAccounts) {
      this.merchantBanks = this.sortMerchantBanksDesc((merchantBankAccounts || []).map((item: MerchantBank) => this.withWithdrawalLabel(item) as MerchantBank));
      this.refreshFilterMerchantBanks({ bankTransactions: this.bankTransactions });
      return;
    }
    this.subscription.push(this.getMerchantBanks().subscribe());
  }

  private getMerchantBanks() {
    const is_crypto = this.withdrawalBankType == 'crypto' ? 1 : 0;
    const merchantBankType = this.from === 'member' ? 1 : 2;

    return this.merchantBankDataService.getWithQuery(`?paginate=false&purpose=${this.purposeId}&currency_id=${this.currencyId}&status[0]=1&status[1]=2&member_id=${this.withdrawalDetails.member_id}&is_crypto=${is_crypto}&merchant_bank_type=${merchantBankType}&withdraw=1`).pipe(
      tap(res => {
        const mapped = (res || []).map(item => this.withWithdrawalLabel(item));
        this.merchantBanks = this.sortMerchantBanksDesc(mapped as MerchantBank[]);
        this.refreshFilterMerchantBanks({'bankTransactions': this.bankTransactions});
      })
    );
  }

  private sortMerchantBanksDesc(list: MerchantBank[]): MerchantBank[] {
    return [...list].sort((a: MerchantBank, b: MerchantBank) => Number(b?.id ?? 0) - Number(a?.id ?? 0));
  }

  isPaymentGatewayTarget(target: any): boolean {
    if (!target) {
      return false;
    }

    return target?.bank_type_name === 'Payment Gateway'
      || Number(target?.method) === 2
      || !!target?.payment_gateway_config_id;
  }

  // AIO-79217: the offline bank is not a gateway target, so it renders in the manual branch - but it
  // still pays out through /withdraw/v2/payout (which routes it to Telegram), not through Approve.
  // Compared case-insensitively on both sides, matching Bank::isOfflineBank()'s strcasecmp: the code
  // is operator-editable in BO, and an exact compare would silently drop the offline actions.
  isOfflineBankSelected(index: number): boolean {
    const bankCode = this.selectedMerchantBank?.[index]?.[0]?.bank_code ?? '';

    return bankCode.toLowerCase() === this.BANK_OFFLINE_CODE.toLowerCase();
  }

  // Prefill applies only to bank-transfer (method 1) targets, via the method === 1 gate below.
  // Ewallet (3) and PayID (8) also have merchant_bank_transaction_configs rows, so the config's
  // existence is NOT the discriminator — they are intentionally excluded by the method gate here and
  // keep their operator-entered fee with no auto-prefill.
  isBankTransferTarget(target: any): boolean {
    if (!target) {
      return false;
    }

    return Number(target?.method) === 1;
  }

  refreshFilterMerchantBanks(res: any) {
    this.existAutoWithdrawRecord = res.bankTransactions.some(
      x => x.approval_type === 1
    );

    this.existPendingAutoWithdrawRecord = res.bankTransactions.some(
      x => x.status === 2
    );

    if (res.withdrawalStatus != undefined) {
      this.withdrawalStatus = res.withdrawalStatus;
    }
    else {
      this.withdrawalStatus = this.withdrawalDetails.status;
    }

    // if (bankTransactionList.length > 0 && this.existAutoWithdrawRecord) {
    //   const merchantBankIds = bankTransactionList.map(
    //     x => x['merchant_bank_id']
    //   );

    //   this.filteredMerchantBanks = this.merchantBanks.filter(
    //     r => !merchantBankIds.includes(r['id'])
    //   );
    // }
    // else {
    //   this.filteredMerchantBanks = [...this.merchantBanks];
    // }

    this.filteredMerchantBanks = [...this.merchantBanks];
    this.safeDetectChanges();
  }

  private safeDetectChanges() {
    const cdrAsAny = this.cdr as any;
    if (this.isDestroyed || cdrAsAny?.destroyed) {
      return;
    }

    this.cdr.detectChanges();
  }

  private formInit() {
    this.form = this.fb.group({
      withdraw_id: new FormControl(this.id),
      merchant_banks: this.banks
    })
  }

  /**
   * The function onChangeTotalProcessingFee checks if the total processing fee entered is valid and
   * updates the error message accordingly.
   * @param {Event} event - The event parameter is an object that represents the event that triggered
   * the onChangeTotalProcessingFee function. It could be an input change event, for example, when the
   * user types in a value in an input field.
   * @param {number} index - The index parameter is a number that represents the index of an element in
   * an array. It is used to access and manipulate specific elements in the array. In this case, it is
   * used to access and update the values in the showTotalProcessingFeeError and
   * totalProcessingFeeErrorText arrays.
   */
  onChangeTotalProcessingFee(event: Event, index: number) {
    this.validateProcessingFee(index);
  }

  // Validates the processing fee for a row. Total must equal Company + Player (in either direction);
  // the error is surfaced under Total so the approve handler (onApproveBankTransaction) blocks and shows
  // it in the system message.
  private validateProcessingFee(index: number) {
    const form = this.banks.value[index];
    const total = +form.total_processing_fee;
    const company = +form.processing_fee;
    const member = +form.member_processing_fee;
    const amount = +form.amount;

    if (total >= amount) {
      this.showTotalProcessingFeeError[index] = true;
      this.totalProcessingFeeErrorText[index] = 'Total should be less than the transaction amount';
    } else if (total < 0) {
      this.showTotalProcessingFeeError[index] = true;
      this.totalProcessingFeeErrorText[index] = 'Total should be greater or equal to 0';
    } else if (Math.round((company + member) * 100) !== Math.round(total * 100)) {
      this.showTotalProcessingFeeError[index] = true;
      this.totalProcessingFeeErrorText[index] = 'Company + Player must be equal to Total';
    } else {
      this.showTotalProcessingFeeError[index] = false;
      this.totalProcessingFeeErrorText[index] = '';
    }

    // Equality is surfaced under Total now; keep the Company-level flag clear.
    this.showProcessingFeeError[index] = false;
    this.processingFeeErrorText[index] = '';

    this.showFeeBreakdownRequired[index] = total > 0 && company === 0 && member === 0;
    this.safeDetectChanges();
  }
  /**
   * The function `onChangeProcessingFee` checks if the sum of `processingFee` and
   * `memberProcessingFee` is greater than `total_processing_fee` and updates the error message
   * accordingly.
   * @param {number} index - The index parameter is a number that represents the index of the bank in
   * the banks array. It is used to access the specific bank object in the array.
   * @param {Event} [event] - The `event` parameter is an optional parameter of type `Event`. It
   * represents the event that triggered the change in the processing fee. It can be used to access
   * information about the event, such as the target element or the event type.
   */
  onChangeProcessingFee(index: number, event?: Event) {
    this.validateProcessingFee(index);
  }

  canShowAmount(amount: number, format: string) {
    let retAmount = '***';
    if( this.canViewWithdrawalAmount ) {
      retAmount = this.decimalPipe.transform(amount, format);
    }
    return retAmount;
  }

}
